"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
class InitializationServiceImpl extends api_shared_js_1.NotificationServiceImplBase {
    get serviceName() {
        return "initialization-service" /* Initialization */;
    }
}
exports.InitializationServiceImpl = InitializationServiceImpl;
//# sourceMappingURL=InitializationServiceImpl.js.map